import { Box } from '@mui/material'
import RecursiveProperty from './RenderJSON'

export const renderCertificates = (data, theme) => {
  const checkDetails = { ...data }
  const rawPdf = data.AdditionalOutputData?.RawResultFile || ''

  if (checkDetails && checkDetails.AdditionalOutputData) {
    delete checkDetails.AdditionalOutputData
  }

  return (
    <Box sx={{ padding: '0', backgroundColor: theme === 'light' ? '#FCFFFD' : '#020D06' }}>
      {rawPdf && <iframe src={rawPdf} width="100%" height="600px" title="PDF Preview" />}
      <RecursiveProperty property={checkDetails} excludeBottomBorder={false} rootProperty={true} />
    </Box>
  )
}
